import { Formik } from 'formik';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react'
import SmallLoader from '../../../SmallLoader';
import { MdError } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import getPlatformInfo, { notifySuccess } from '../../../../action/customFn';
import axios from "../../../../axios";
import { setLogin } from '../../../../action/loginAction';
import { useNavigate } from 'react-router-dom';
import OTPInput from 'react-otp-input';

function VerifyOTPForm({ googleError, setFormStage }) {
  const userIpInfo = useSelector(state => state?.paymentData?.userIpInfo);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <Formik
      initialValues={{ otp: '' }}
      validate={values => {
        const errors = {};
        return errors;
      }}
      onSubmit={async (values, { setSubmitting, setStatus }) => {
        try {
          const url = "/user/verify-otp";
          const postData = {
            email: localStorage.getItem("otp_email"),
            otp: values.otp
          };
          const res = await axios.post(url, postData);
          const { message } = res.data;
          notifySuccess(message);
          // navigate("/login/new-password");
          setFormStage("UPDATE__PASSWORD");
          localStorage.setItem("otp_verify", values.otp);
          setSubmitting(false)
        } catch (error) {
          console.log(error);
          setStatus({ success: false, error: true, message: error.response?.data?.message })
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        status,
        setFieldValue
      }) => (
        <AnimatePresence>

          <motion.form initial={{ x: -100, opacity: 0 }} animate={{ x: 0, opacity: 1 }} exit={{ x: 100, opacity: 0 }} onSubmit={handleSubmit}>
            <AnimatePresence>
              {(status?.error || googleError?.error) && <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="error-holder">
                <div style={{ width: "20px", fontSize: "20px" }}>
                  <MdError />
                </div>
                <span>{status?.message || googleError?.msg}</span>
              </motion.div>}
            </AnimatePresence>
            {!status && <div style={{ marginTop: "20px" }}></div>}

            <OTPInput
              value={values.otp}
              onChange={(str) => { setFieldValue("otp", str) }}
              numInputs={4}
              inputType="tel"
              containerStyle={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "30px" }}
              renderInput={(props) => <input {...props} style={{ textAlign: 'center', aspectRatio: "1/1", marginBottom: "20px" }} />}
              inputStyle={"login_otp_inp"}
            />

            <button disabled={isSubmitting} className="submit" type="submit" >
              {isSubmitting ? <SmallLoader color={"#ffff"} /> : "Verify"}
            </button>
            <button onClick={() => { navigate(-1) }} disabled={isSubmitting} className="submit submit-secondary" style={{ background: "rgba(12,12,55,0.05)" }} type="button" >
              Cancel
            </button>
          </motion.form>
        </AnimatePresence>
      )}
    </Formik>
  )
}

export default VerifyOTPForm
